import React, { useState } from 'react';
import { FadeIn, Button, CountdownTimer } from './Shared';
import { Check } from 'lucide-react';
export const PricingSection = () => {
  const [plan, setPlan] = useState<'standard' | 'premium'>('premium');
  const plans = {
    standard: {
      id: 'standard',
      icon: '📘',
      title: 'MEGAPACK NOCHES DE PAZ',
      subtitle: '5 Tomos + 5 Bonos',
      ideal: 'Ideal para: Familias que buscan el sistema base probado.',
      oldPrice: '$61.000',
      price: '$19.990',
      url: 'https://mundopractico.online/cart/48588077203673:1',
      buttonText: 'MEGAPACK'
    },
    premium: {
      id: 'premium',
      icon: '🏆',
      title: 'MEGAPACK + RECONEXIÓN',
      subtitle: '5 Tomos + 5 Bonos + Guía de Pareja Post-Caos',
      ideal: 'Ideal para: Parejas que quieren recuperar su descanso y su conexión.',
      oldPrice: '$79.000',
      price: '$27.990',
      url: 'https://mundopractico.online/cart/48588081660121:1',
      buttonText: 'MEGAPACK + RECONEXIÓN',
      isPopular: true
    }
  };
  const currentPlan = plans[plan];
  return <section id="pricing" className="py-6 md:py-10 px-4 bg-navy-950 relative overflow-hidden" data-id="element-191">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-192">
        <FadeIn data-id="element-193">
          <div className="text-center mb-10" data-id="element-194">
            <h2 className="text-sm font-bold tracking-widest text-red-400 uppercase mb-6" data-id="element-195">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>
            <CountdownTimer data-id="element-196" />

            <div className="max-w-sm mx-auto mt-8 bg-navy-800/40 border border-navy-700/50 rounded-xl p-4 backdrop-blur-sm" data-id="element-197">
              <div className="flex justify-between items-center text-xs font-bold mb-2 uppercase tracking-wider" data-id="element-198">
                <span className="text-gray-300 flex items-center gap-1.5" data-id="element-199">
                  <span className="w-1.5 h-1.5 rounded-full bg-red-400 animate-pulse" data-id="element-200"></span>
                  Alta demanda
                </span>
                <span className="text-red-400" data-id="element-201">89% Reclamado</span>
              </div>
              <div className="h-1.5 bg-navy-900 rounded-full overflow-hidden border border-navy-800" data-id="element-202">
                <div className="h-full bg-gradient-to-r from-yellow-500 via-amber-500 to-red-500 w-[89%] rounded-full relative" data-id="element-203">
                  <div className="absolute inset-0 bg-white/20 animate-pulse" data-id="element-204"></div>
                </div>
              </div>
              <p className="text-[11px] text-gray-400 mt-2.5 font-medium" data-id="element-205">
                Últimos accesos disponibles a precio de lanzamiento
              </p>
            </div>

            <p className="text-gray-200 mt-6 font-medium" data-id="element-206">
              ⚠️ Después sube $5.000 ARS. No vuelve.
            </p>
            <h3 className="text-3xl md:text-5xl font-serif font-black text-white mt-10 mb-8 uppercase tracking-tight" data-id="element-207">
              ELEGÍ TU <span className="text-green-500" data-id="element-208">MEGAPACK</span>
            </h3>
          </div>

          <div id="planes-container" className="space-y-4 mb-8 scroll-mt-24" data-id="element-209">
            {(Object.values(plans) as any[]).map(p => {
            const isSelected = plan === p.id;
            return <button key={p.id} id={`plan-${p.id}`} onClick={() => setPlan(p.id)} className={`w-full text-left transition-all duration-300 rounded-2xl p-6 md:p-8 border-2 flex items-center gap-4 md:gap-6 relative overflow-hidden scroll-mt-28 md:scroll-mt-32 ${isSelected ? 'bg-gradient-to-br from-navy-800 to-navy-900 border-yellow-400 shadow-[0_0_30px_rgba(250,204,21,0.15)] transform scale-[1.02] z-10' : 'bg-navy-800/60 border-navy-700 hover:border-navy-600 hover:bg-navy-800'}`} data-id="element-210">
                  {isSelected && <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-yellow-400 to-amber-500" data-id="element-211" />}

                  {/* Radio Indicator */}
                  <div className={`w-6 h-6 rounded-full border-2 shrink-0 flex items-center justify-center transition-colors ${isSelected ? 'border-yellow-400 bg-yellow-400/10' : 'border-gray-500 bg-navy-900/50'}`} data-id="element-212">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-yellow-400 shadow-[0_0_10px_rgba(250,204,21,0.8)]" data-id="element-213" />}
                  </div>

                  {/* Content */}
                  <div className="flex-grow min-w-0" data-id="element-214">
                    <div className="flex items-center flex-wrap gap-2 mb-1" data-id="element-215">
                      <span className="text-xl shrink-0" data-id="element-216">{p.icon}</span>
                      <h4 className={`text-base md:text-xl font-bold uppercase tracking-tight break-words ${isSelected ? 'text-yellow-400' : 'text-white'}`} data-id="element-217">
                        {p.title}
                      </h4>
                      {p.isPopular && <span className="text-[10px] md:text-xs bg-gradient-to-r from-yellow-400 to-amber-500 text-navy-950 font-black px-3 py-0.5 rounded-full shadow-[0_0_15px_rgba(250,204,21,0.4)] uppercase tracking-wider ml-1" data-id="element-218">
                          ⭐ MÁS ELEGIDO
                        </span>}
                    </div>
                    <p className={`text-xs md:text-base mb-1 break-words ${isSelected ? 'text-gray-100' : 'text-gray-300'}`} data-id="element-219">
                      {p.subtitle}
                    </p>
                    <p className={`text-[10px] md:text-sm font-medium break-words ${isSelected ? 'text-yellow-200/90' : 'text-gray-400'}`} data-id="element-220">
                      {p.ideal}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right shrink-0 ml-auto" data-id="element-221">
                    <p className={`line-through text-[10px] md:text-sm mb-1 ${isSelected ? 'text-gray-300' : 'text-gray-400'}`} data-id="element-222">
                      {p.oldPrice}
                    </p>
                    <p className={`text-xl md:text-4xl font-black transition-colors ${isSelected ? 'text-yellow-400 drop-shadow-[0_0_10px_rgba(250,204,21,0.4)]' : 'text-white'}`} data-id="element-223">
                      {p.price}{' '}
                      <span className={`text-[10px] md:text-sm font-bold block md:inline ${isSelected ? 'text-yellow-400/70' : 'text-gray-400'}`} data-id="element-224">
                        ARS
                      </span>
                    </p>
                  </div>
                </button>;
          })}
          </div>

          <div className="mt-10" data-id="element-225">
            <a href={currentPlan.url} className="w-full bg-gradient-to-r from-yellow-400 via-yellow-500 to-amber-500 hover:from-yellow-300 hover:via-yellow-400 hover:to-amber-400 text-navy-950 font-black text-lg md:text-2xl py-5 md:py-6 px-4 rounded-2xl flex items-center justify-center transition-all transform hover:scale-[1.03] active:scale-[0.98] shadow-[0_0_40px_rgba(250,204,21,0.4)] border border-yellow-300/50 text-center break-words leading-tight relative overflow-hidden group" data-id="element-226">
              <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-shine" data-id="element-227" />
              <span className="relative z-10" data-id="element-228">
                → QUIERO EL {currentPlan.buttonText}
              </span>
            </a>
            <div className="flex flex-col items-center mt-6 text-gray-200 text-sm gap-2" data-id="element-229">
              <p className="flex items-center gap-2" data-id="element-230">
                <span className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse" data-id="element-231" />
                Acceso inmediato por email • Pago seguro
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};